import { Route, UrlSegment } from '@angular/router';

export const validateProductGuard = (_route: Route, segments: UrlSegment[]) => {
	const products = ['undergraduate', 'postgraduate'];

	return products.includes(segments[0].path);
};
